import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import {toast} from "react-toastify";
import {
    BARCODE_DIGITS,
    BARCODE_LENGTH,
    BARCODE_TYPE,
    PRODUCT_TYPE,
    PRODUCT_UNIT,
    STATUS,
    STOCK_EVENT,
    STOCK_EVENT_ADD_REASON,
    STOCK_EVENT_DROP_REASON,
    TILL_IMAGE,
    WEB_IMAGE_SERVER_URL,
    WEB_MENU_SMALL_IMAGE
} from "../../shared/utils/Constants";
import {InputSwitch} from "primereact/inputswitch";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import {Checkbox} from "primereact/checkbox";
import {InputNumber} from "primereact/inputnumber";
import {FileUpload} from "primereact/fileupload";
import {Button as ButtonSearch} from "primereact/components/button/Button";
import DepartmentService from "../../shared/service/DepartmentService";
import TaxService from "../../shared/service/TaxService";
import ProductService from "../../shared/service/ProductService";
import {MultiSelect} from "primereact/multiselect";
import TagService from "../../shared/service/TagService";
import CountryService from "../../shared/service/CountryService";
import ProductClassService from "../../shared/service/ProductClassService";
import './ProductPriceCalculator.css';
import SupplierService from "../../shared/service/SupplierService";
import Decimal from "./decimal.mjs";
import {AutoComplete} from "primereact/autocomplete";
import DeposImageService from "../../shared/service/DeposImageService";
import '../../shared/styles/SettingsPage.css';
import './ProductPages.css';
import FormSection from '../../shared/component/form/FormSection';

const defaultProduct = {
    id: '',
    name: '',
    status: 'ACTIVE',
    barcode: '',
    departmentId: null,
    departmentProfitMargin: null,
    departmentTaxId: null,
    tax: null,
    price: null,
    price4: null,
    webPrice: null,
    price2: null,
    price3: null,
    webImagePath: null,
    unit: null,
    quantity: 1,
    weighable: false,
    allowZeroPrice: false,
    allowNegativePrice: false,
    productType: 'PRODUCT_LINE',
    fileType: '',
    fileName: '',
    fileTypeTill: '',
    fileNameTill: '',
    productTags: [],
    mixAndMatchName: '',
    minStock: null,
    maxStock: null,
    currentStock: null,
    stockOperation: '',
    stockOperationReason: '',
    stock: null,
    supplierId: null,
    countryId: null,
    productClassId: null,
    description: '',
    rowNumber: 1000,
    colNo: 10,
    costPrice: 0,
    boxQuantity: null,
    boxUnit: 'each',
    profitMargin: null,
    boxPrice: 0,
    unitCost: 0,
    actualMargin: null,
    retailPrice: 0,
    codeLength: 7,
    menu:false
};


export default class ProductSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            product: defaultProduct,
            productTemp: defaultProduct,
            productDetailsSaveButtonRender: false,
            stockDetailsSaveButtonRender: false,
            defaultStatus: 'ACTIVE',
            taxList: [],
            tagList: [],
            departmentList: [],
            countryList: [],
            productClassList: [],
            supplierList: [],
            filteredProducts: []
        }
        this.productService = new ProductService();
        this.departmentService = new DepartmentService();
        this.taxService = new TaxService();
        this.productTagService = new TagService();
        this.countryService = new CountryService();
        this.productClassService = new ProductClassService();
        this.supplierService = new SupplierService();
        this.deposImageService = new DeposImageService();
    }

    componentDidMount() {

        let id = window.location.href.split('?')[1];
        if (!GeneralUtils.__isValueEmpty(id)) {

            this.productService.findById(id).then(response => {
                    let responseObject = Object.assign({}, response);
                    let responseObjectTemp = Object.assign({}, response);
                    this.setState({

                    });

                this.setState({
                    product: responseObject, productTemp: responseObjectTemp
                }, () => {
                    if (response != null && response.barcode != null && response.name != null) {
                        this.getDeposImagePath(response.barcode, response.name);
                    }
                    this.calculateFields();
                    this.calculateWebPrice()
                });

                }
            );

            this.calculateFields();
        } else {
            let obj1 = Object.assign({}, defaultProduct);
            this.setState({
                product: obj1,
                productDetailsSaveButtonRender: true,
                stockDetailsSaveButtonRender: true,
                productTemp: Object.assign({}, obj1)
            });

        }

        this.taxService.findAll().then(response => this.setState({taxList: response}));
        this.departmentService.findAll().then(response => this.setState({departmentList: response}));
        this.productTagService.findAllActive().then(response => this.setState({tagList: response}));
        this.countryService.findAll().then(response => this.setState({countryList: response}));
        this.productClassService.findAll().then(response => this.setState({productClassList: response}));
        this.supplierService.findAll().then(response => this.setState({supplierList: response}));

    }

    render() {
        return (
            <div className="settings-page settings-page--full settings-page--form-page col-md-12">
                <AvForm autocomplete="off">
                    <div className="settings-page__panel product-save-page">
                        <div className="settings-page__header settings-page__header--in-panel">
                            <h1 className="settings-page__title">Product Details</h1>
                        </div>
                        {this.productDetails()}
                    </div>
                </AvForm>
            </div>
        );
    }


    setCheckedStatus = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.product.id)) {
            this.productService.updateStatus(this.state.product.id, this.state.defaultStatus)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            product: response,
                            productDetailsSaveButtonRender: false,
                            stockDetailsSaveButtonRender: false,
                            productTemp: Object.assign({}, response)
                        });
                    }
                });
        } else {
            let product = this.state.product;
            product["status"] = this.state.product.status == "ACTIVE" ? "PASSIVE" : "ACTIVE";
            this.setState({product: product, productTemp: Object.assign({}, product)});
        }

        return undefined;
    }


    showChangeStatusConfirmDialog = (value) => {
        let defaultStatus = 'PASSIVE';
        if (value) {
            defaultStatus = 'ACTIVE'
        }
        this.setState({
            displayShowStatusConfirmDialog: true,
            defaultStatus: defaultStatus,
            noticeResponse: "You are about to change the status. Are you sure?"
        });
    }
    setChecked = (name, value) => {
        let product = this.state.product;
        product[name] = value;
        this.setState({product: product});
    }

    downloadDocument = (type) => {
        if (!GeneralUtils.isNullOrEmpty(this.state.product.id)) {
            this.productService.downloadDocument(this.state.product.id, type).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response.file)) {
                    GeneralUtils.convertToDownloadableFile(response);
                }
            });
        }
    }

    productDetails() {

        return (<div className="product-save-page__form">
            <div className="product-save-page__details">
                <Row>
                    <Col md="9">
                        <div className="product-save-page__fields-stack">
                            <div className="product-save-page__grid-5 product-save-page__grid-5--aligned">
                                <div className="product-save-page__grid-cell product-save-page__status-col">
                                    <AvGroup>
                                        <Label for="status">
                                            <Translate contentKey="producttradingName">Status</Translate>
                                        </Label>
                                        <div className="product-save-page__status-inline">
                                            <AvField
                                                type="select"
                                                className="form-control product-save-page__status-select"
                                                name="status"
                                                disabled={true}
                                                value={this.state.product.status}
                                                onChange={this.__handleChange}>
                                                {STATUS.map(element => (
                                                    <option value={element.value} key={element.value}>
                                                        {element.name}
                                                    </option>))}
                                            </AvField>
                                            <ModalConfirm header='Warning' ok='OK' onOkClick={this.setCheckedStatus}
                                                          onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                                                          show={this.state.displayShowStatusConfirmDialog}
                                                          message={this.state.noticeResponse}/>
                                            <ModalConfirm header='Warning' ok='OK' onOkClick={this.deleteProduct}
                                                          onCancelClick={() => this.setState({displayDeleteConfirmDialog: false})}
                                                          show={this.state.displayDeleteConfirmDialog}
                                                          message={this.state.noticeResponse}/>
                                            <div className="product-save-page__status-switch-wrap">
                                                <InputSwitch checked={this.state.product.status == "ACTIVE" ? true : false}
                                                             tooltip={"Change Status"}
                                                             disabled={!this.state.productDetailsSaveButtonRender}
                                                             onChange={(e) => this.showChangeStatusConfirmDialog(e.value)}/>
                                            </div>
                                        </div>
                                    </AvGroup>
                                </div>
                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="product-barcode">
                                            <Translate contentKey="producttradingName">Barcode</Translate>
                                            <span style={{color: 'red'}}> (*)</span>
                                        </Label>
                                        <AvField
                                            id="product-barcode"
                                            type="number"
                                            className="form-control"
                                            name="barcode"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            max="99999999999999"
                                            value={this.state.product.barcode}
                                            onChange={this.__handleChange}/>
                                    </AvGroup>
                                </div>
                                {(this.state.product.id == "" || this.state.product.id == null || GeneralUtils.isNullOrEmpty(this.state.product.barcode)) && this.state.productDetailsSaveButtonRender ?
                                    <div className="product-save-page__grid-cell product-save-page__generate-barcode-col">
                                        <AvGroup>
                                            <Label className="product-save-page__generate-barcode-label">&nbsp;</Label>
                                            <div className="product-save-page__generate-barcode-wrap">
                                                <Button color="outline-primary"
                                                        className="settings-page__btn--action settings-page__btn--nowrap product-save-page__generate-barcode-btn"
                                                        onClick={() => {
                                                            this.productService.getNextBarcode().then(response => {
                                                                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                                                    let product = this.state.product;
                                                                    product["barcode"] = response.barcode;
                                                                    this.setState({product: product});
                                                                }
                                                            });
                                                        }}>
                                                    <Translate contentKey="entity.action.add">Generate Barcode</Translate>
                                                </Button>
                                            </div>
                                        </AvGroup>
                                    </div>
                                    : this.state.product.barcode != null && this.state.product.barcode.length >= 12 ?
                                    <div className="product-save-page__grid-cell">
                                        <AvGroup>
                                            <Label for="product-barcode-type">
                                                <Translate contentKey="producttradingName">Barcode Type</Translate>
                                            </Label>
                                            <AvField id="product-barcode-type" type="select" className="form-control" name="barcodeType"
                                                disabled={!this.state.productDetailsSaveButtonRender}
                                                value={this.state.product.barcodeType} onChange={this.__handleChange}>
                                                {BARCODE_TYPE.map(element => (
                                                    <option value={element.value} key={element.value}>{element.name}</option>))}
                                            </AvField>
                                        </AvGroup>
                                    </div>
                                    : <div className="product-save-page__grid-cell product-save-page__grid-cell--empty" aria-hidden="true" />}
                                {this.state.product.barcode != null && this.state.product.barcode.length >= 12 ?
                                    <div className="product-save-page__grid-cell">
                                        <AvGroup>
                                            <Label for="product-barcode-digit"><Translate contentKey="producttradingName">Barcode Digit</Translate></Label>
                                            <AvField id="product-barcode-digit" type="select" className="form-control" name="barcodeDigit"
                                                disabled={!this.state.productDetailsSaveButtonRender} value={this.state.product.barcodeDigit} onChange={this.__handleChange}>
                                                <option value='' key=''/>
                                                {BARCODE_DIGITS.map(element => (<option value={element.value} key={element.value}>{element.name}</option>))}
                                            </AvField>
                                        </AvGroup>
                                    </div>
                                    : <div className="product-save-page__grid-cell product-save-page__grid-cell--empty" aria-hidden="true" />}
                                {this.state.product.barcode != null && this.state.product.barcode.length >= 12 ?
                                    <div className="product-save-page__grid-cell">
                                        <AvGroup>
                                            <Label for="product-code-length"><Translate contentKey="producttradingName">Code Length</Translate></Label>
                                            <AvField id="product-code-length" type="select" className="form-control" name="codeLength"
                                                disabled={!this.state.productDetailsSaveButtonRender} value={this.state.product.codeLength} onChange={this.__handleChange}>
                                                <option value='' key=''/>
                                                {BARCODE_LENGTH.map(element => (<option value={element.value} key={element.value}>{element.name}</option>))}
                                            </AvField>
                                        </AvGroup>
                                    </div>
                                    : <div className="product-save-page__grid-cell product-save-page__grid-cell--empty" aria-hidden="true" />}
                            </div>

                            <div className="product-save-page__grid-5 product-save-page__grid-5--aligned">
                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName"><Translate contentKey="producttradingName">Name</Translate><span style={{color: 'red'}}> (*)</span></Label>
                                        <AutoComplete value={this.state.product.name} suggestions={this.state.filteredProducts} completeMethod={this.searchProduct} field="name"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            onChange={(e) => { if (!GeneralUtils.isNullOrEmpty(e.value.id)) { this.setState({selectedProduct: e.value, product: e.value}); this.getDeposImagePath(e.value.barcode, e.value.name); } }} />
                                    </AvGroup>
                                </div>
                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName"><Translate contentKey="producttradingName">Quantity</Translate><span style={{color: 'red'}}> (*)</span></Label>
                                        <InputNumber name="quantity" disabled={!this.state.productDetailsSaveButtonRender} value={this.state.product.quantity}
                                            onChange={this.__handleChange} className="product-save-page__price-input" locale="en-US" />
                                    </AvGroup>
                                </div>
                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName"><Translate contentKey="producttradingName">Unit</Translate><span style={{color: 'red'}}> (*)</span></Label>
                                        <AvField type="select" className="form-control" name="unit" disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.unit} onChange={this.__handleChange}>
                                            <option value='' key=''/>
                                            {PRODUCT_UNIT.map(element => (<option value={element.value} key={element.value}>{element.name}</option>))}
                                        </AvField>
                                    </AvGroup>
                                </div>
                                <div className="product-save-page__grid-cell product-save-page__grid-cell--checkbox">
                                    <AvGroup className="product-save-page__checkbox-group">
                                        <Label for="product-weighable"><Translate contentKey="productfirstName">Weighable</Translate></Label>
                                        <div className="product-save-page__checkbox-control">
                                            <Checkbox onChange={(e) => this.setChecked("weighable", e.checked)} name="weighable"
                                                disabled={!this.state.productDetailsSaveButtonRender} value={this.state.product.weighable} checked={this.state.product.weighable}/>
                                        </div>
                                    </AvGroup>
                                </div>
                                <div className="product-save-page__grid-cell product-save-page__grid-cell--checkbox">
                                    <AvGroup className="product-save-page__checkbox-group">
                                        <Label for="product-menu"><Translate contentKey="productfirstName">Menu</Translate></Label>
                                        <div className="product-save-page__checkbox-control">
                                            <Checkbox onChange={(e) => this.setChecked("menu", e.checked)} name="menu"
                                                disabled={!this.state.productDetailsSaveButtonRender} value={this.state.product.menu} checked={this.state.product.menu}/>
                                        </div>
                                    </AvGroup>
                                </div>
                            </div>

                            <div className="product-save-page__grid-5 product-save-page__grid-5--aligned">
                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="mobilePhone"><Translate contentKey="contactManagement.mobilePhone">Department</Translate><span style={{color: 'red'}}> (*)</span></Label>
                                        <AvField type="select" disabled={!this.state.productDetailsSaveButtonRender} className="form-control" name="departmentId"
                                            value={this.state.product.departmentId} onChange={this.__handleChange}>
                                            <option value='' key=''/>
                                            {this.state.departmentList.map(element => (<option value={element.id} key={element.id}>{element.name}</option>))}
                                        </AvField>
                                    </AvGroup>
                                </div>
                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="mobilePhone"><Translate contentKey="contactManagement.mobilePhone">Tax</Translate></Label>
                                        <AvField type="select" disabled={!this.state.productDetailsSaveButtonRender} className="form-control" name="tax"
                                            style={this.state.product.tax != null && this.state.product.departmentTaxId != this.state.product.tax ? {color: 'red'} : {color: 'black'}}
                                            value={this.state.product.tax} onChange={this.__handleChange}>
                                            <option value='' key=''/>
                                            {this.state.taxList.map(element => (<option value={element.id} key={element.id}>{element.name}</option>))}
                                        </AvField>
                                    </AvGroup>
                                </div>
                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="cityId"><Translate contentKey="location.cityId">Product Tag</Translate></Label>
                                        <MultiSelect value={this.state.product.productTags} options={this.state.tagList} name="productTags"
                                            disabled={!this.state.productDetailsSaveButtonRender} onChange={this.__handleChange} optionLabel="name"
                                            placeholder="Select a Product Tag" maxSelectedLabels={4}/>
                                    </AvGroup>
                                </div>
                                <div className="product-save-page__grid-cell product-save-page__grid-cell--empty" aria-hidden="true" />
                                <div className="product-save-page__grid-cell product-save-page__grid-cell--empty" aria-hidden="true" />
                            </div>
                        </div>
                        <FormSection title="Price">
                            <div className="product-save-page__grid-5 product-save-page__grid-5--aligned">
                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Till Price</Translate>
                                            <span style={{color: 'red'}}> (*)</span>
                                        </Label>

                                        <InputNumber
                                            name="price"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.price}
                                            onChange={this.__handleChange}
                                            mode="currency"
                                            className="product-save-page__price-input"
                                            currency="GBP" locale="en-US"
                                        />
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Price 2</Translate>
                                        </Label>

                                        <InputNumber
                                            name="price2"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.price2}
                                            onChange={this.__handleChange}
                                            mode="currency"
                                            className="product-save-page__price-input"
                                            currency="GBP" locale="en-US"
                                        />
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Price 3</Translate>
                                        </Label>

                                        <InputNumber
                                            name="price3"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.price3}
                                            onChange={this.__handleChange}
                                            mode="currency"
                                            className="product-save-page__price-input"
                                            currency="GBP" locale="en-US"
                                        />
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Price 4</Translate>
                                        </Label>
                                        <InputNumber
                                            name="price4"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.price4}
                                            onChange={this.__handleChange}
                                            mode="currency"
                                            className="product-save-page__price-input"
                                            currency="GBP" locale="en-US"
                                        />
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell product-save-page__grid-cell--web-price">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Web Price</Translate>
                                        </Label>
                                        <div className="product-save-page__web-price-row">
                                            <InputNumber
                                                name="webPrice"
                                                disabled={true}
                                                value={this.state.product.webPrice}
                                                onChange={this.__handleChange}
                                                mode="currency"
                                                className="product-save-page__price-input product-save-page__web-price-input"
                                                currency="GBP" locale="en-US"
                                            />
                                            {GeneralUtils.checkPrivilege("put_product/product/all") &&
                                                <ButtonSearch
                                                    type="button"
                                                    icon="pi pi-refresh"
                                                    className="product-save-page__calc-web-icon-btn"
                                                    disabled={!this.state.productDetailsSaveButtonRender}
                                                    tooltip="Calculate Web Price"
                                                    tooltipOptions={{position: 'top'}}
                                                    onClick={() => this.calculateWebPrice()}
                                                />}
                                        </div>
                                    </AvGroup>
                                </div>
                            </div>
                        </FormSection>


                        <FormSection title="Stock Management">
                            <div className="product-save-page__grid-5 product-save-page__grid-5--aligned product-save-page__grid-5--stock">
                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Current Stock</Translate>
                                        </Label>
                                        <InputNumber
                                            name="currentStock"
                                            disabled={true}
                                            value={this.state.product.currentStock}
                                            onChange={this.__handleChange}
                                            className="product-save-page__price-input"
                                        />
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Min Stock</Translate>
                                        </Label>
                                        <InputNumber
                                            name="minStock"
                                            disabled={!this.state.stockDetailsSaveButtonRender}
                                            value={this.state.product.minStock}
                                            onChange={this.__handleChange}
                                            className="product-save-page__price-input"
                                        />
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Max Stock</Translate>
                                        </Label>
                                        <InputNumber
                                            name="maxStock"
                                            disabled={!this.state.stockDetailsSaveButtonRender}
                                            value={this.state.product.maxStock}
                                            onChange={this.__handleChange}
                                            className="product-save-page__price-input"
                                        />
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Stock Operation</Translate>
                                        </Label>
                                        <AvField
                                            type="select"
                                            className="form-control"
                                            name="stockOperation"
                                            disabled={!this.state.stockDetailsSaveButtonRender}
                                            value={this.state.product.stockOperation}
                                            onChange={this.__handleChange}>
                                            <option value='' key=''/>
                                            {STOCK_EVENT.map(element => (
                                                <option value={element.value} key={element.value}>
                                                    {element.name}
                                                </option>))}
                                        </AvField>
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Stock</Translate>
                                        </Label>
                                        <InputNumber
                                            name="stock"
                                            disabled={!this.state.stockDetailsSaveButtonRender}
                                            value={this.state.product.stock}
                                            onChange={this.__handleChange}
                                            className="product-save-page__price-input"
                                        />
                                    </AvGroup>
                                </div>
                                {(this.state.product.stockOperation == "ADD_STOCK" || this.state.product.stockOperation == "DROP_STOCK") &&
                                    <div className="product-save-page__grid-cell product-save-page__grid-cell--stock-reason">
                                        <AvGroup>
                                            <Label for="product-stock-reason">
                                                <Translate contentKey="producttradingName">Stock Operation Reason</Translate>
                                            </Label>
                                            <AvField
                                                id="product-stock-reason"
                                                type="select"
                                                className="form-control"
                                                name="stockEventReason"
                                                disabled={!this.state.stockDetailsSaveButtonRender}
                                                value={this.state.product.stockEventReason}
                                                onChange={this.__handleChange}>
                                                {(this.state.product.stockOperation == "ADD_STOCK"
                                                    ? STOCK_EVENT_ADD_REASON
                                                    : STOCK_EVENT_DROP_REASON
                                                ).map(element => (
                                                    <option value={element.value} key={element.value}>
                                                        {element.name}
                                                    </option>))}
                                            </AvField>
                                        </AvGroup>
                                    </div>
                                }
                                <div className={`product-save-page__grid-cell product-save-page__grid-cell--stock-actions product-save-page__stock-actions settings-page__actions settings-page__actions--inline ${!(this.state.product.stockOperation == "ADD_STOCK" || this.state.product.stockOperation == "DROP_STOCK") ? "product-save-page__grid-cell--stock-actions-full" : ""}`}>
                                    {!GeneralUtils.isNullOrEmpty(this.state.product.id) && GeneralUtils.checkPrivilege("post_product/product") && this.state.stockDetailsSaveButtonRender == false &&
                                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                                            this.setState({
                                                productDetailsSaveButtonRender: false,
                                                stockDetailsSaveButtonRender: true
                                            });
                                        }}>
                                            <Translate contentKey="entity.action.add">Edit Stock</Translate>
                                        </Button>}

                                    {!GeneralUtils.isNullOrEmpty(this.state.product.id) && GeneralUtils.checkPrivilege("post_product/product") && this.state.stockDetailsSaveButtonRender &&
                                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                                            this.updateStock();
                                        }}>
                                            <Translate contentKey="entity.action.add">Save Stock</Translate>
                                        </Button>
                                    }

                                    {!GeneralUtils.isNullOrEmpty(this.state.product.id) && GeneralUtils.checkPrivilege("post_product/product") && this.state.stockDetailsSaveButtonRender &&
                                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                                            let obj1 = this.state.productTemp;

                                            this.setState({
                                                product: Object.assign({}, obj1),
                                                productDetailsSaveButtonRender: false,
                                                stockDetailsSaveButtonRender: false
                                            });
                                        }}>
                                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                                        </Button>
                                    }
                                </div>
                            </div>

                        </FormSection>

                        <FormSection title="Promotions">
                            <div className="product-save-page__grid-5 product-save-page__grid-5--aligned product-save-page__grid-5--promotions">
                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Delivery</Translate>
                                        </Label>
                                        <InputNumber
                                            name="price3"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.price3}
                                            onChange={this.__handleChange}
                                            mode="currency"
                                            className="product-save-page__price-input"
                                            currency="GBP" locale="en-US"
                                        />
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Promotions</Translate>
                                        </Label>
                                        <AvField
                                            type="text"
                                            className="form-control"
                                            name="mixAndMatchName"
                                            disabled={true}
                                            value={this.state.product.mixAndMatchName}
                                            onChange={this.__handleChange}
                                        />
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell product-save-page__grid-cell--checkbox">
                                    <AvGroup className="product-save-page__checkbox-group">
                                        <Label for="allowZeroPrice">
                                            <Translate contentKey="productfirstName">Zero Price</Translate>
                                        </Label>
                                        <div className="product-save-page__checkbox-control">
                                            <Checkbox onChange={(e) => this.setChecked("allowZeroPrice", e.checked)}
                                                      name="allowZeroPrice"
                                                      disabled={!this.state.productDetailsSaveButtonRender}
                                                      value={this.state.product.allowZeroPrice}
                                                      checked={this.state.product.allowZeroPrice}/>
                                        </div>
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell product-save-page__grid-cell--checkbox">
                                    <AvGroup className="product-save-page__checkbox-group">
                                        <Label for="allowNegativePrice">
                                            <Translate contentKey="productfirstName">Negative Price</Translate>
                                        </Label>
                                        <div className="product-save-page__checkbox-control">
                                            <Checkbox onChange={(e) => this.setChecked("allowNegativePrice", e.checked)}
                                                      name="allowNegativePrice"
                                                      disabled={!this.state.productDetailsSaveButtonRender}
                                                      value={this.state.product.allowNegativePrice}
                                                      checked={this.state.product.allowNegativePrice}/>
                                        </div>
                                    </AvGroup>
                                </div>

                                <div className="product-save-page__grid-cell">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Product Type</Translate>
                                        </Label>
                                        <AvField
                                            type="select"
                                            className="form-control"
                                            name="productType"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.productType}
                                            onChange={this.__handleChange}>
                                            {PRODUCT_TYPE.map(element => (
                                                <option value={element.value} key={element.value}>
                                                    {element.name}
                                                </option>))}
                                        </AvField>
                                    </AvGroup>
                                </div>
                            </div>
                        </FormSection>

                    </Col>


                    <Col md="3" className="product-save-page__sidebar">
                        <div className="product-save-page__image-stack">
                                <FormSection title="Image (Web)" className="settings-page__form-section--compact">
                                    <div className="product-save-page__image-panel">
                                        <div className="product-save-page__image-row">
                                            <div className="product-save-page__image-upload">
                                                <FileUpload name="demo"
                                                            accept="image/*"
                                                            maxFileSize={50000}
                                                            onValidationFailError={GeneralUtils.onValidationFailErrorFile}
                                                            invalidFileSizeMessageDetail="Maximum upload size is 50K."
                                                            chooseLabel="Choose"
                                                            disabled={!this.state.productDetailsSaveButtonRender}
                                                            onSelect={(e) => this.__handleImageSelect('fileName', e)}
                                                            ref={elem => this.refUploadInputImage = elem}
                                                            mode="basic"/>
                                            </div>
                                            <div className="product-save-page__image-toolbar">
                                                <ButtonSearch icon="pi pi-minus"
                                                              disabled={!this.state.productDetailsSaveButtonRender}
                                                              onClick={() => {
                                                    this.removeDocument(WEB_MENU_SMALL_IMAGE)
                                                }}/>
                                                <img
                                                    className="product-save-page__image-thumb"
                                                    alt=""
                                                    src={!GeneralUtils.isNullOrEmpty(this.state.product.webImagePath) ? WEB_IMAGE_SERVER_URL + this.state.product.webImagePath : "assets/layout/images/white.png"}
                                                    onError={(e) => e.target.src = 'assets/layout/images/white.png'}
                                                />
                                            </div>
                                        </div>
                                        {this.__showImageFileName(this.state.product.fileName) &&
                                            <span className="product-save-page__image-filename"
                                                  title={this.state.product.fileName}>
                                                {this.state.product.fileName}
                                            </span>}
                                    </div>
                                </FormSection>

                        </div>
                        <FormSection title="Price Calculator" className="product-save-page__price-calculator">
                            <Row>


                                <Col md="6">
                                    <AvGroup>
                                        <Label for="mobilePhone">
                                            <Translate contentKey="contactManagement.mobilePhone">Supplier</Translate>
                                        </Label>

                                        <AvField
                                            type="select"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            className="form-control"
                                            name="supplierId"
                                            value={this.state.product.supplierId}
                                            onChange={this.__handleChange}>
                                            <option value='' key=''/>
                                            {this.state.supplierList.map(element => (
                                                <option value={element.id} key={element.id}>
                                                    {element.name}
                                                </option>))}
                                        </AvField>

                                    </AvGroup>
                                </Col>

                                <Col md="6">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Box Cost</Translate>
                                        </Label>
                                        <InputNumber
                                            name="costPrice"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.costPrice}
                                            onChange={this.__handleChange}
                                            mode="currency"
                                            currency="GBP" locale="en-US"
                                        />
                                    </AvGroup>
                                </Col>

                                <Col md="6">

                                    <AvGroup>
                                        <Label for="cityId">
                                            <Translate
                                                contentKey="location.cityId">Box Quantity</Translate>
                                        </Label>

                                        <AvField
                                            type="number"
                                            className="form-control"
                                            name="boxQuantity"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.boxQuantity}
                                            onChange={this.__handleChange}>

                                        </AvField>
                                    </AvGroup>

                                </Col>

                                <Col md="6">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Box Unit</Translate>
                                        </Label>
                                        <AvField
                                            type="select"
                                            className="form-control"
                                            name="boxUnit"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.boxUnit}
                                            onChange={this.__handleChange}>
                                            {PRODUCT_UNIT.map(element => (
                                                <option value={element.value} key={element.value}>
                                                    {element.name}
                                                </option>))}
                                        </AvField>
                                    </AvGroup>
                                </Col>

                                <Col md="6">

                                    <AvGroup>
                                        <Label for="cityId">
                                            <Translate
                                                contentKey="location.cityId">Profit Margin</Translate>
                                        </Label>

                                        <AvField
                                            type="number"
                                            className="form-control"
                                            name="profitMargin"
                                            step="1"
                                            onKeyDown={(e) => [".", ",", "e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                            style={this.state.product.departmentProfitMargin != this.state.product.profitMargin ? {color: 'red'} : {color: 'black'}}
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.profitMargin}
                                            onChange={this.__handleChange}>

                                        </AvField>
                                    </AvGroup>

                                </Col>


                                <Col md="6">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Box Price</Translate>
                                        </Label>
                                        <InputNumber
                                            name="boxPrice"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.boxPrice}
                                            onChange={this.__handleChange}
                                            mode="currency"
                                            currency="GBP" locale="en-US"
                                        />
                                    </AvGroup>
                                </Col>

                                <Col md="6">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Unit Cost</Translate>
                                        </Label>

                                        <InputNumber
                                            name="unitCost"
                                            disabled={true}
                                            value={this.state.product.unitCost}
                                            onChange={this.__handleChange}
                                            mode="currency"
                                            currency="GBP" locale="en-US"
                                        />
                                    </AvGroup>
                                </Col>


                                <Col md="6">

                                    <AvGroup>
                                        <Label for="cityId">
                                            <Translate
                                                contentKey="location.cityId">Actual Margin</Translate>
                                        </Label>

                                        <AvField
                                            type="number"
                                            className="form-control"
                                            name="actualMargin"
                                            disabled={true}
                                            value={this.state.product.actualMargin}
                                            onChange={this.__handleChange}>

                                        </AvField>
                                    </AvGroup>

                                </Col>


                                <Col md="6">
                                    <AvGroup>
                                        <Label for="tradingName">
                                            <Translate contentKey="producttradingName">Retail Price</Translate>
                                        </Label>

                                        <InputNumber
                                            name="retailPrice"
                                            disabled={true}
                                            value={this.state.product.retailPrice}
                                            onChange={this.__handleChange}
                                            mode="currency"
                                            currency="GBP" locale="en-US"
                                        />
                                    </AvGroup>
                                </Col>

                            </Row>

                        </FormSection>
                        <FormSection title="Till">
                            <Row>
                                <Col md="6">
                                    <AvGroup>
                                        <Label for="mobilePhone">
                                            <Translate contentKey="contactManagement.mobilePhone">Class</Translate>
                                        </Label>

                                        <AvField
                                            type="select"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            className="form-control"
                                            name="productClassId"
                                            value={this.state.product.productClassId}
                                            onChange={this.__handleChange}>
                                            <option value='' key=''/>
                                            {this.state.productClassList.map(element => (
                                                <option value={element.id} key={element.id}>
                                                    {element.name}
                                                </option>))}
                                        </AvField>

                                    </AvGroup>
                                </Col>

                                <Col md="6">
                                    <AvGroup>
                                        <Label for="mobilePhone">
                                            <Translate contentKey="contactManagement.mobilePhone">Origin</Translate>
                                        </Label>

                                        <AvField
                                            type="select"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            className="form-control"
                                            name="countryId"
                                            value={this.state.product.countryId}
                                            onChange={this.__handleChange}>
                                            <option value='' key=''/>
                                            {this.state.countryList.map(element => (
                                                <option value={element.id} key={element.id}>
                                                    {element.name}
                                                </option>))}
                                        </AvField>

                                    </AvGroup>
                                </Col>


                                <Col md="6">

                                    <AvGroup>
                                        <Label for="cityId">
                                            <Translate
                                                contentKey="location.cityId">Row</Translate>
                                        </Label>

                                        <AvField
                                            type="number"
                                            className="form-control"
                                            name="rowNumber"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.rowNumber}
                                            onChange={this.__handleChange}>

                                        </AvField>
                                    </AvGroup>

                                </Col>

                                <Col md="6">

                                    <AvGroup>
                                        <Label for="cityId">
                                            <Translate
                                                contentKey="location.cityId">Col</Translate>
                                        </Label>

                                        <AvField
                                            type="number"
                                            className="form-control"
                                            name="colNo"
                                            disabled={!this.state.productDetailsSaveButtonRender}
                                            value={this.state.product.colNo}
                                            onChange={this.__handleChange}>

                                        </AvField>
                                    </AvGroup>

                                </Col>

                            </Row>

                        </FormSection>
                                <FormSection title="Image (Till)" className="settings-page__form-section--compact product-save-page__image-till-section">
                                    <div className="product-save-page__image-panel">
                                        <div className="product-save-page__image-row">
                                            <div className="product-save-page__image-upload">
                                                <FileUpload name="demo"
                                                            maxFileSize={50000}
                                                            onValidationFailError={GeneralUtils.onValidationFailErrorFile}
                                                            invalidFileSizeMessageDetail="Maximum upload size is 50K."
                                                            accept="image/*"
                                                            chooseLabel="Choose"
                                                            disabled={!this.state.productDetailsSaveButtonRender}
                                                            onSelect={(e) => this.__handleImageSelect('fileNameTill', e)}
                                                            ref={elem => this.refUploadInputImageTill = elem}
                                                            mode="basic"/>
                                            </div>
                                            <div className="product-save-page__image-toolbar">
                                                <ButtonSearch icon="pi pi-search" onClick={(e) => {
                                                    if (e.detail == 1) {
                                                        try {
                                                            GeneralUtils.previewDocument(this.refUploadInputImageTill)
                                                        } catch (err) {
                                                            this.downloadDocument(TILL_IMAGE);
                                                        }
                                                    }
                                                }}/>
                                                <ButtonSearch icon="pi pi-minus"
                                                              disabled={!this.state.productDetailsSaveButtonRender}
                                                              onClick={() => {
                                                    this.removeDocument(TILL_IMAGE)
                                                }}/>
                                            </div>
                                        </div>
                                        {this.__showImageFileName(this.state.product.fileNameTill) &&
                                            <span className="product-save-page__image-filename"
                                                  title={this.state.product.fileNameTill}>
                                                {this.state.product.fileNameTill}
                                            </span>}
                                    </div>
                                </FormSection>

                    </Col>


                </Row>


                <div className="settings-page__actions">
                    {GeneralUtils.checkPrivilege("post_product/product") && this.state.productDetailsSaveButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({productDetailsSaveButtonRender: true, stockDetailsSaveButtonRender: false});
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}

                    {GeneralUtils.checkPrivilege("post_product/product") && this.state.productDetailsSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.saveProduct("save");
                        }}>
                            <Translate contentKey="entity.action.add">Save</Translate>
                        </Button>
                    }

                    {GeneralUtils.checkPrivilege("post_product/product") && this.state.productDetailsSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save settings-page__btn--wrap"
                                onClick={() => {
                            this.saveProduct("saveAndNext");
                        }}>
                            <Translate contentKey="entity.action.add">SaveAndNext</Translate>
                        </Button>}

                    {GeneralUtils.checkPrivilege("post_product/product") && this.state.productDetailsSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save settings-page__btn--wrap"
                                onClick={() => {
                            this.saveProduct("saveAndCopy");
                        }}>
                            <Translate contentKey="entity.action.add">SaveAndCopy</Translate>
                        </Button>}

                    {GeneralUtils.checkPrivilege("post_product/product") && this.state.productDetailsSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                            let obj1 = this.state.productTemp;

                            if (GeneralUtils.isNullOrEmpty(obj1.id)) {
                                window.history.back();
                            } else {
                                this.setState({
                                    product: Object.assign({}, obj1), productDetailsSaveButtonRender: false
                                });
                            }
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>
                    }

                    {GeneralUtils.checkPrivilege("delete_product/product/_id") && !this.state.productDetailsSaveButtonRender &&
                        <Button color="outline-danger" className="settings-page__btn--delete" onClick={() => {
                            this.showDeleteConfirmDialog()
                        }}>
                            <Translate contentKey="entity.action.add">Delete</Translate>
                        </Button>
                    }

                    <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--back" onClick={() => {
                        window.location.href = "#productList";
                    }}>
                        <Translate contentKey="entity.action.cancel">Back</Translate>
                    </Button>
                </div>

            </div>
        </div>)
    };

    showDeleteConfirmDialog = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.product.id)) {
            return toast.warn("Select a product!");
        } else {
            this.setState({
                displayDeleteConfirmDialog: true,
                noticeResponse: "The product will be deleted. Do you want to continue?"
            });
        }
    }

    returnListPage = () => {
        window.location.href = "#productList";
    }

    deleteProduct = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.product.id)) {
            this.productService.delete(this.state.product.id)
                .then((response) => {
                    this.returnListPage();
                });
        }
    }

    updateStock = () => {
        if (!GeneralUtils.isNullOrEmpty(this.state.product.id)) {
            this.productService.updateStock(this.state.product)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            productDetailsSaveButtonRender: false,
                            stockDetailsSaveButtonRender: false,
                            product: response,
                            productTemp: Object.assign({}, response)

                        });
                    }
                });
            this.calculateFields();
        }

    }
    saveProduct = (type) => {
        if (GeneralUtils.isNullOrEmpty(this.state.product.name) ||
            GeneralUtils.isNullOrEmpty(this.state.product.barcode) ||
            GeneralUtils.isNullOrEmpty(this.state.product.quantity) ||
            GeneralUtils.isNullOrEmpty(this.state.product.departmentId) ||
            GeneralUtils.isNullOrEmpty(this.state.product.unit)
        ) {
            return toast.warn("Please fill the required fields!");
        } else {

            if(!GeneralUtils.isNullOrEmpty(this.state.product.barcodeType) && (this.state.product.barcodeType=="PRICE" || this.state.product.barcodeType=="WEIGHT")  && this.state.product.barcode != null && this.state.product.barcode.length >= 12 && (GeneralUtils.isNullOrEmpty(this.state.product.codeLength) || GeneralUtils.isNullOrEmpty(this.state.product.barcodeDigit)  )){
                return toast.warn("Please fill the Code Length and Barcode Digit");
            }
            else{
                if (!GeneralUtils.isNullOrEmpty(this.state.product.id)) {
                    this.productService.update(this.state.product)
                        .then((response) => {
                            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                if (type == "save") {
                                    this.setState({
                                        productDetailsSaveButtonRender: false,
                                        stockDetailsSaveButtonRender: false,
                                        product: response,
                                        productTemp: Object.assign({}, response)

                                    });
                                    this.returnListPage();
                                } else if (type == "saveAndNext") {
                                    let obj1 = Object.assign({}, defaultProduct);
                                    this.setState({
                                        product: obj1,
                                        productTemp: Object.assign({}, obj1),
                                        stockDetailsSaveButtonRender: true,
                                        productDetailsSaveButtonRender: true,

                                    });
                                }
                                if (type == "saveAndCopy") {
                                    let obj1 = Object.assign({}, response);
                                    obj1.id = null;
                                    obj1.barcode = null;
                                    this.setState({
                                        product: obj1,
                                        productTemp: Object.assign({}, obj1),
                                        stockDetailsSaveButtonRender: true,
                                        productDetailsSaveButtonRender: true,

                                    });
                                }

                                this.uploadDocument(response.id);
                            }
                        });
                    this.calculateFields();
                } else {
                    this.productService.create(this.state.product)
                        .then((response) => {
                            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                if (type == "save") {
                                    this.setState({
                                        productDetailsSaveButtonRender: false,
                                        stockDetailsSaveButtonRender: false,
                                        product: response,
                                        productTemp: Object.assign({}, response)
                                    });
                                    this.returnListPage();
                                } else if (type == "saveAndNext") {
                                    let obj1 = Object.assign({}, defaultProduct);
                                    this.setState({
                                        product: obj1, productTemp: Object.assign({}, obj1),
                                        stockDetailsSaveButtonRender: true, productDetailsSaveButtonRender: true,

                                    });
                                }
                                if (type == "saveAndCopy") {
                                    let obj1 = Object.assign({}, response);
                                    obj1.id = null;
                                    obj1.barcode = null;
                                    this.setState({
                                        product: obj1, productTemp: Object.assign({}, obj1),
                                        stockDetailsSaveButtonRender: true, productDetailsSaveButtonRender: true,

                                    });
                                }

                                this.uploadDocument(response.id);
                            }
                        });
                    this.calculateFields();
                }
            }




        }
    }


    getDeposImagePath(barcode, name) {
        this.deposImageService.findProductImagePath(barcode, encodeURIComponent(name), "DEFAULT", localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type) && !GeneralUtils.isNullOrEmpty(response.webImagePath)) {
                    let product = this.state.product;
                    product["webImagePath"] = response.webImagePath;
                    this.setState({product: product});
                }
            });
    }

    removeDocument(type) {
        if (!GeneralUtils.isNullOrEmpty(this.state.product.id)) {
            this.productService.removeDocument(this.state.product.id, type).then(response => {
                this.setState({
                    productDetailsSaveButtonRender: false,
                    product: response,
                })
            });
        }

        if (type == WEB_MENU_SMALL_IMAGE) {
            this.refUploadInputImage.clear();
            const product = Object.assign({}, this.state.product, {fileName: ''});
            this.setState({product});
        } else {
            this.refUploadInputImageTill.clear();
            const product = Object.assign({}, this.state.product, {fileNameTill: ''});
            this.setState({product});
        }

    }

    __showImageFileName = (fileName) => {
        return !GeneralUtils.isNullOrEmpty(fileName) && fileName !== 'Choose';
    }

    __handleImageSelect = (field, e) => {
        if (!e.files || !e.files.length) {
            return;
        }
        const product = Object.assign({}, this.state.product);
        product[field] = e.files[0].name;
        this.setState({product});
    }

    uploadDocument(id) {
        let image = this.refUploadInputImage.files;
        let imageTill = this.refUploadInputImageTill.files;
        if (!(GeneralUtils.isNullOrEmpty(image) || GeneralUtils.isNullOrEmpty(image.length))) {
            let formData = new FormData();
            if (!GeneralUtils.isNullOrEmpty(image) && !GeneralUtils.isNullOrEmpty(image.length)) {
                formData.append("file", image[0]);
                this.productService.uploadDocument(id, formData, WEB_MENU_SMALL_IMAGE).then(response => {
                    this.setState({
                        productDetailsSaveButtonRender: false,
                        stockDetailsSaveButtonRender: false,
                    })
                });
            }
        }

        if (!(GeneralUtils.isNullOrEmpty(imageTill) || GeneralUtils.isNullOrEmpty(imageTill.length))) {
            let formData = new FormData();
            if (!GeneralUtils.isNullOrEmpty(imageTill) && !GeneralUtils.isNullOrEmpty(imageTill.length)) {
                formData.append("file", imageTill[0]);
                this.productService.uploadDocument(id, formData, TILL_IMAGE).then(response => {
                    this.setState({
                        productDetailsSaveButtonRender: false,
                        stockDetailsSaveButtonRender: false,
                    })
                });
            }
        }
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let product = this.state.product;
        if (e.target.name === "profitMargin" && value !== null && value !== undefined && value !== '') {
            value = parseInt(value, 10);
            if (Number.isNaN(value)) {
                value = '';
            }
        }
        product[e.target.name] = value;

        if (e.target.name == "barcode" && value.length < 12) {
            product['barcodeType'] = 'NORMAL';
            product['barcodeDigit'] = null;
            product['codeLength'] = null;
        }
        if (e.target.name == "departmentId") {
            var departmentProfitMargin = this.state.departmentList.filter(x => x.id == value).map(x => x.profitMargin)[0];
            if (GeneralUtils.isNullOrEmpty(product['profitMargin'])) {
                product['profitMargin'] = departmentProfitMargin;
                product['departmentProfitMargin'] = departmentProfitMargin;
            } else {
                product['departmentProfitMargin'] = departmentProfitMargin;
            }

            var departmentTaxId = this.state.departmentList.filter(x => x.id == value).map(x => x.tax)[0];
            product['tax'] = departmentTaxId;
            product['departmentTaxId'] = departmentTaxId;

        }
        if (e.target.name == "stockOperation") {
            if (value == "ADD_STOCK") {
                product['stockOperationReason'] = "DELIVERY";
            } else if (value == "DROP_STOCK") {
                product['stockOperationReason'] = "EXPIRED";
            } else {
                product['stockOperationReason'] = "";
            }
        }

        this.setState({product: product});

        this.calculateFields();
    }


    calculateWebPrice = () => {
        let product = this.state.product;
        if (!GeneralUtils.isNullOrEmpty(product.price)) {
            this.productService.calculateWebPrice(product).then(response => {
                product["webPrice"] = response;
                this.setState({product: product});
            });
        }


    }

    calculateFields = () => {
        try {
            var HUNDRED = new Decimal(100);
            let product = this.state.product;

            product['retailPrice'] = null;
            product['actualMargin'] = null;
            product['unitCost'] = null;
            var boxQty = new Decimal(product.boxQuantity ? product.boxQuantity : 1);
            var vatRate = (new Decimal(product.tax ? this.state.taxList.filter(x => x.id == product.tax).map(x => x.rate)[0] : (product.departmentId ? this.state.departmentList.filter(x => x.id == product.departmentId).map(x => x.taxRate)[0] : 0.0))).plus(HUNDRED).div(HUNDRED);
            // cost is assumed to be VAT exclude
            var unitCost = (new Decimal(product.costPrice ? product.costPrice : 0.0)).div(boxQty);
            var costPrice = unitCost.times(vatRate);
            var itemPrice = new Decimal(product.price ? product.price : 0.0);
            var profitMarginRate = (new Decimal(product.profitMargin ? product.profitMargin : 0.0)).plus(HUNDRED).div(HUNDRED);

            product['unitCost'] = parseFloat(unitCost);

            if (parseFloat(costPrice)) {
                product['actualMargin'] = parseFloat((itemPrice.div(costPrice).times(HUNDRED).minus(HUNDRED)).toFixed(2));
            }

            product['retailPrice'] = parseFloat((profitMarginRate.times(costPrice)).toFixed(2));

            this.setState({product: product});
        } catch (e) {

        }

    }

    searchProduct = (event) => {
        let value = event.query;
        let product = this.state.product;
        product["name"] = value;
        this.setState({
            product: product,
        });

        setTimeout(() => {
            this.productService.searchProductsByName(value).then(response => {
                this.setState({filteredProducts: response});

            });
        }, 250);

    }

}

